function initFaleConoscoPopup() {
  const popup = document.getElementById("FaleConoscoPopup");
  if (!popup) return;

  // Evita múltiplos binds (DOMContentLoaded + shopify:section:load)
  if (popup.dataset.faleConoscoInitialized === "true") return;
  popup.dataset.faleConoscoInitialized = "true";

  const TRANSITION_MS = 400;

  const openButtons = document.querySelectorAll("[data-open-fale]");
  const closeButtons = popup.querySelectorAll("[data-close-fale]");
  const accordionHeaders = popup.querySelectorAll(".fale-accordion-header");
  const popupContent = popup.querySelector(".fale-popup-modal"); // Área interna do popup

  // Estado inicial: sempre oculto até o clique (evita flash sem CSS)
  popup.classList.remove("is-open");
  popup.setAttribute("aria-hidden", "true");
  popup.setAttribute("hidden", "");

  const openPopup = () => {
    // Fechar menu lateral se estiver aberto
    const menuDrawer = document.querySelector("menu-drawer");
    if (menuDrawer && menuDrawer.classList.contains("menu-opening")) {
      menuDrawer.close();
    }

    popup.removeAttribute("hidden");
    requestAnimationFrame(() => {
      popup.classList.add("is-open");
      popup.setAttribute("aria-hidden", "false");
      document.body.classList.add("no-scroll");
    });

    // Foco no primeiro elemento focável
    setTimeout(() => {
      const firstFocusable = popup.querySelector(".fale-popup-close");
      firstFocusable?.focus();
    }, TRANSITION_MS);
  };

  const closePopup = () => {
    popup.classList.remove("is-open");
    popup.setAttribute("aria-hidden", "true");
    document.body.classList.remove("no-scroll");

    // Fechar todos os accordions com delay para animação suave
    setTimeout(() => {
      popup.querySelectorAll(".fale-accordion.is-open").forEach((a) => {
        a.classList.remove("is-open");
      });
      popup.setAttribute("hidden", "");
    }, TRANSITION_MS);
  };

  const togglePopup = () => {
    if (popup.classList.contains("is-open")) {
      closePopup();
    } else {
      openPopup();
    }
  };

  // Fechar Fale Conosco quando menu lateral abrir
  document.addEventListener("menu-drawer:open", () => {
    if (popup.classList.contains("is-open")) {
      closePopup();
    }
  });

  // Fechar ao clicar no overlay OU fora da área de conteúdo
  popup.addEventListener("click", (e) => {
    // Se clicar diretamente no popup (fundo) mas NÃO no conteúdo
    if (
      e.target === popup ||
      e.target.classList.contains("fale-popup-overlay")
    ) {
      closePopup();
    }
  });

  // Prevenir fechamento ao clicar dentro do conteúdo
  if (popupContent) {
    popupContent.addEventListener("click", (e) => {
      e.stopPropagation();
    });
  }

  // Accordions
  accordionHeaders.forEach((header) => {
    header.addEventListener("click", () => {
      const accordion = header.closest(".fale-accordion");
      const isOpen = accordion.classList.contains("is-open");

      // Fechar outros accordions
      popup.querySelectorAll(".fale-accordion.is-open").forEach((a) => {
        if (a !== accordion) {
          a.classList.remove("is-open");
        }
      });

      // Toggle atual
      accordion.classList.toggle("is-open", !isOpen);
    });
  });

  // TOGGLE popup ao clicar no botão (abre E fecha)
  openButtons.forEach((btn) =>
    btn.addEventListener("click", (e) => {
      e.preventDefault();
      e.stopPropagation();
      togglePopup();
    })
  );

  // Fechar popup com botão X
  closeButtons.forEach((btn) => {
    btn.addEventListener("click", (e) => {
      e.preventDefault();
      e.stopPropagation();
      closePopup();
    });
  });

  // ESC para fechar
  document.addEventListener("keydown", (e) => {
    if (e.key === "Escape" && popup.classList.contains("is-open")) {
      closePopup();
    }
  });
}

document.addEventListener("DOMContentLoaded", initFaleConoscoPopup);
document.addEventListener("shopify:section:load", initFaleConoscoPopup);
